<!--
 * @Author: lbh
 * @Date: 2021-07-30 09:53:43
 * @LastEditors: lbh
 * @LastEditTime: 2022-03-22 15:11:06
 * @Description: file content
-->
<template>
  <van-nav-bar
    class="self_nav-bar"
    :class=" color ? 'self_bg_color' : transparent ? '' : ''"
    ref="headNavs"
    :style="{ backgroundColor: color ? color : transparent ? 'transparent' : '#FFF', color: white ? '#fff' : color ? '#fff' : '#5f5f5f' }"
    :title="title"
    fixed
    :z-index="100"
    :right-text="rightText"
    @click-right="islogin"
  >
    <img
      class="cell-logo self-logo"
      v-if="!title && !flag"
      :src="themeLogo"
      alt=""
      slot="title"
    />
    <img
      class="cell-logo self-logo"
      v-if="!title && flag"
      :src="themeLogo"
      alt=""
      slot="title"
    />
    <van-icon
      size="20"
      @click="backFn"
      :color="color ? '#fff' : '#5f5f5f'"
      v-if="back"
      slot="left"
      name="arrow-left"
    />
    <van-icon
      size="20"
      @click="toHome"
      :color="color ? '#fff' : '#5f5f5f'"
      v-else-if="!back && home"
      slot="left"
      class-prefix="home_icon"
      name="extra"
    />

    <template
      v-if="showScan && showScan_"
      #right
    >
      <van-icon
        name="scan"
        size="24"
      />
    </template>
  </van-nav-bar>
</template>

<script>
export default {
  name: 'headNav',
  data () {
    return {
      showScan_: false
    }
  },
  methods: {
    backFn () {
      var self = this;
      setTimeout(function () {
        self.$router.back();
      }, 300);
    },
    toHome () {
      // location.replace('https://www.thefoodstoryhk.com/');
    },
    islogin () {
      this.$emit('rightClick');
    }
  },
  mounted () {
    // 設置頭部標題
    console.log(this.color);
    console.log(this.color ? '#fff' : '#5f5f5f');
    if (this.title && this.$refs.headNavs && this.$refs.headNavs.querySelector) this.$refs.headNavs.querySelector('.van-nav-bar__title').style.color = this.color ? '#fff' : '#5f5f5f';
    if (this.white && this.$refs.headNavs && this.$refs.headNavs.querySelector) this.$refs.headNavs.querySelector('.van-nav-bar__title').style.color = '#FFF';
    if (location.origin.indexOf('gingersoft.com') > -1) {
      this.showScan_ = true;
    }
    console.log(this.showScan_);
  },
  props: ['back', 'title', 'rightText', 'color', 'home', 'flag', 'transparent', 'white', "showScan"]
};
</script>

<style scoped>
@font-face {
  font-family: "home_icon";
  src: url("../iconfont/iconfont.ttf") format("truetype");
}

.home_icon {
  font-family: "home_icon";
  font-style: normal;
}

.home_icon-extra::before {
  content: "\e600";
}

.cell-logo {
  max-width: 100%;
  /* padding: 20px 0 */
}

.self-logo {
  height: 40px;
  margin-top: 3px;
}

.self_nav-bar .van-nav-bar__text {
  font-size: 17px !important;
  line-height: 17px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/headNav.vue